import { format } from 'date-fns';

export const makeDeadline = (deadline, customFormat = null) =>
  `Deadline: ${deadline ? format(new Date(deadline), customFormat || 'MMM yyyy') : 'on a rolling basis'}`;

export const makeStartDate = ({ startDate, length }, customFormat = null) =>
  [
    startDate && `Start date: ${format(new Date(startDate), customFormat || 'MMM yyyy')}`,
    startDate && length && ', ',
    length && `Length: ${length} months`
  ]
    .filter(Boolean)
    .join('');
